import React from 'react';
import { Layout } from '../components/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { orthodonticAppliancesHref } from '../utils/localizedRoutes';
import { MapPin, Calendar, MessageCircle, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
export function SitemapPage() {
  const {
    lang
  } = useTranslation();
  return <Layout data-id="element-4503" data-mp="2uckbhvmi2cbj">
      <section className="py-16 bg-white" data-id="element-4504" data-mp="2ud2erc7kxqsy">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4505" data-mp="38dd4ud12f1d2">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-4506" data-mp="38cllq1onmw3o">
            Dentico Clinic Sitemap
          </h1>
          <p className="text-lg text-gray-600 mb-12" data-id="element-4507" data-mp="33c7fmp6m5w8a">
            Welcome to Dentico Clinic, Private Dental Clinic in Angel, London
            EC1V.
          </p>

          <div className="space-y-10" data-id="element-4508" data-mp="191kgt5w996ch">
            {/* Main Pages */}
            <div data-id="element-4509" data-mp="3jfi2rtm8efnc">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4510" data-mp="3jg1ayim2xpo6">
                Main Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-4511" data-mp="3obp04y0kaito">
                <li data-id="element-4512" data-mp="3sfekfba7ee8w">
                  <Link to={`/${lang}`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4513" data-mp="3se3jrkc21mm0">
                    Home – Private Dentist in Angel, London
                  </Link>
                </li>
                <li data-id="element-4514" data-mp="ay3vm08pi5dp">
                  <Link to={`/${lang}/about`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4515" data-mp="axlqsf7zaiu6">
                    About Us – Meet Our Dental Team
                  </Link>
                </li>
                <li data-id="element-4516" data-mp="2hqxv632kf3hw">
                  <Link to={`/${lang}/contact`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4517" data-mp="2hrfoaqtxl1ll">
                    Contact – Book Appointment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Language Versions */}
            <div data-id="element-4518" data-mp="1xo5f86up0sd">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4519" data-mp="1y7c1sr1w2r3">
                Language Versions
              </h2>
              <ul className="space-y-2.5" data-id="element-4520" data-mp="bvlqjmteyhgr">
                <li data-id="element-4521" data-mp="buk6isuf6kmw">
                  <Link to="/en" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4522" data-mp="btr6eapyutdq">
                    🇬🇧 English Version
                  </Link>
                </li>
                <li data-id="element-4523" data-mp="gm24d815c53n">
                  <Link to="/ua" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4524" data-mp="gnmy4vfmzk0g">
                    🇺🇦 Ukrainian Version
                  </Link>
                </li>
                <li data-id="element-4525" data-mp="1991woig9q6xu">
                  <Link to="/ru" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4526" data-mp="199trhr21k0n2">
                    🇷🇺 Russian Version
                  </Link>
                </li>
              </ul>
            </div>

            {/* Dental Services */}
            <div data-id="element-4527" data-mp="147w18cv845km">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4528" data-mp="14bjurc0o4rzc">
                Dental Services
              </h2>
              <ul className="space-y-2.5" data-id="element-4529" data-mp="va2he1enb4ec">
                <li data-id="element-4530" data-mp="vb3ra2jxdkuh">
                  <Link to={`/${lang}/services`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4531" data-mp="gkeg306gs5qm">
                    All Services
                  </Link>
                </li>
                <li data-id="element-4532" data-mp="7k83dgilb9si">
                  <Link to={`/${lang}/prices#consultations`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4533" data-mp="cijfxz09ryef">
                    Dental Examinations & Consultations
                  </Link>
                </li>
                <li data-id="element-4534" data-mp="3qxelzstrnc7s">
                  <Link to={`/${lang}/services/hygiene`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4535" data-mp="3qwwlul3zgdul">
                    Professional Hygiene & Airflow
                  </Link>
                </li>
                <li data-id="element-4536" data-mp="3cx3wou83u5oq">
                  <Link to={`/${lang}/services/fillings`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4537" data-mp="3cwlpj2jwm721">
                    White Fillings
                  </Link>
                </li>
                <li data-id="element-4538" data-mp="167p8pk8pnyh7">
                  <Link to={`/${lang}/services/root-canal`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4539" data-mp="1665tlwysjth0">
                    Root Canal Treatment
                  </Link>
                </li>
                <li data-id="element-4540" data-mp="2p1ibci4kt22o">
                  <Link to={`/${lang}/services/crowns`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4541" data-mp="2p10i7ud7n3yz">
                    Crowns & Bridges
                  </Link>
                </li>
                <li data-id="element-4542" data-mp="2154mmlfg6b0d">
                  <Link to={`/${lang}/services/smile-makeover`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4543" data-mp="215nzvou5kb82">
                    Veneers & Smile Makeover
                  </Link>
                </li>
                <li data-id="element-4544" data-mp="2f4x5jukqfmxs">
                  <Link to={`/${lang}/services/extraction`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4545" data-mp="2f5fdhogrbplj">
                    Tooth Extraction
                  </Link>
                </li>
                <li data-id="element-4546" data-mp="1qfgldc711ys9">
                  <Link to={`/${lang}/services/whitening`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4547" data-mp="1qj4gugw18v9m">
                    Teeth Whitening
                  </Link>
                </li>
                <li data-id="element-4548" data-mp="1vgnrz7xforxc">
                  <Link to={`/${lang}/services/cosmetic`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4549" data-mp="1ve1kt9eggefn">
                    Cosmetic Treatments
                  </Link>
                </li>
                <li data-id="element-4550" data-mp="1hho5a5then3t">
                  <Link to={`/${lang}/services/orthodontics`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4551" data-mp="1hi6bnv9uyhpg">
                    Orthodontics
                  </Link>
                </li>
                <li data-id="element-4552" data-mp="k0pfsv6ylprw">
                  <Link to={orthodonticAppliancesHref(lang)} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4553" data-mp="jz4t1rqvzb4l">
                    Orthodontic Appliances
                  </Link>
                </li>
              </ul>
            </div>

            {/* Specialist Pages (UA) */}
            <div data-id="element-4554" data-mp="2qprcneam274j">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4555" data-mp="2qn5aju6hojtp">
                Specialist Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-4556" data-mp="3je5b1v5m35gm">
                <li data-id="element-4557" data-mp="3jbsxrvastj9w">
                  <Link to="/ua/ukrainskyi-stomatolog-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4558" data-mp="35e4cwngqec4u">
                    🇺🇦 Ukrainian Dentist in London
                  </Link>
                </li>
                <li data-id="element-4559" data-mp="1yy23y7r4qxdw">
                  <Link to="/ua/implanty-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4560" data-mp="1yybv3ynwval6">
                    Dental Implants in London (UA)
                  </Link>
                </li>
                <li data-id="element-4561" data-mp="2gn7574odpyq8">
                  <Link to="/ua/veneers-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4562" data-mp="2gmnry19obyij">
                    Veneers in London (UA)
                  </Link>
                </li>
                <li data-id="element-4563" data-mp="34d9z7qbuterh">
                  <Link to="/ua/root-canal-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4564" data-mp="34crue5b4ls7y">
                    Root Canal in London (UA)
                  </Link>
                </li>
                <li data-id="element-4565" data-mp="3s349c04sgp81">
                  <Link to="/ua/emergency-dentist-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4566" data-mp="3s3nppcesj5jy">
                    Emergency Dentist in Angel (UA)
                  </Link>
                </li>
              </ul>
            </div>

            {/* Blog */}
            <div data-id="element-4567" data-mp="8ftwzj5x7dk0">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4568" data-mp="8farx31dcjne">
                Blog
              </h2>
              <ul className="space-y-2.5" data-id="element-4569" data-mp="dgi0337fbkul">
                <li data-id="element-4570" data-mp="hgic6h71vjyh">
                  <Link to={`/${lang}/blog`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4571" data-mp="hha9bwgappqv">
                    All Articles
                  </Link>
                </li>
                <li data-id="element-4572" data-mp="r8o4js17s3e7">
                  <Link to={`/${lang}/blog/dental-implants-cost-london`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4573" data-mp="w552fdy7tw4h">
                    Скільки коштують імпланти в Лондоні?
                  </Link>
                </li>
                <li data-id="element-4574" data-mp="1j2brf5i142p2">
                  <Link to={`/${lang}/blog/nhs-vs-private-dentistry-uk`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4575" data-mp="1j2v7shs16j0z">
                    NHS vs Private Dentistry in the UK
                  </Link>
                </li>
                <li data-id="element-4576" data-mp="1xrrfgdq6du12">
                  <Link to={`/${lang}/blog/dental-treatment-uk-without-insurance`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4577" data-mp="1xs9lu36jxomp">
                    Лікування зубів у UK без страховки
                  </Link>
                </li>
                <li data-id="element-4578" data-mp="2gp2djv02mhex">
                  <Link to={`/${lang}/blog/toothache-london-what-to-do`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4579" data-mp="2go9frjj3b28x">
                    Зубний біль у Лондоні — що робити?
                  </Link>
                </li>
                <li data-id="element-4580" data-mp="esk1otxfrxh4">
                  <Link to={`/${lang}/blog/veneers-london-everything-you-need-to-know`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4581" data-mp="et3b1m90tdjj">
                    Вініри в Лондоні — що потрібно знати
                  </Link>
                </li>
                <li data-id="element-4582" data-mp="xqmp54ac5mct">
                  <Link to={`/${lang}/blog/how-to-choose-dentist-angel`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4583" data-mp="xqwdyojn9ngx">
                    Як обрати стоматолога в Angel
                  </Link>
                </li>
              </ul>
            </div>

            {/* Pricing */}
            <div data-id="element-4584" data-mp="38io5qhe85iil">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4585" data-mp="38j7cd1yfckhb">
                Pricing
              </h2>
              <ul className="space-y-2.5" data-id="element-4586" data-mp="33i1j930uqv79">
                <li data-id="element-4587" data-mp="1vkf7yfsjufah">
                  <Link to={`/${lang}/prices`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4588" data-mp="1vjw1pwc9hfca">
                    Dental Fees – Transparent Private Prices
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-4589" data-mp="1qmvuhi3oe6jl">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4590" data-mp="1bwetfzuydin8">
                Legal
              </h2>
              <ul className="space-y-2.5" data-id="element-4591" data-mp="1gnoiay8oghy2">
                <li data-id="element-4592" data-mp="1gopw3ah2vijh">
                  <Link to={`/${lang}/privacy-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4593" data-mp="12w06kw2cbvhm">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-4594" data-mp="szn4b9sqc9b9">
                  <Link to={`/${lang}/cookie-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4595" data-mp="xw3z2mufplxb">
                    Cookie Policy
                  </Link>
                </li>
                <li data-id="element-4596" data-mp="abcv1vh8pxyw">
                  <Link to={`/${lang}/patient-privacy-notice`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4597" data-mp="o8i0pud1kutm">
                    Patient Privacy Notice
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Footer info */}
          <div className="mt-16 pt-8 border-t border-gray-200" data-id="element-4598" data-mp="t5rtnjzn3om7">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 text-gray-600" data-id="element-4599" data-mp="16xy20jwjwrb3">
              <div className="flex items-center gap-2" data-id="element-4600" data-mp="120pst8tdrxlz">
                <MapPin className="w-4 h-4 text-teal-600" data-id="element-4601" data-mp="1gx709oyg8s39" />
                <span data-id="element-4602" data-mp="1gvcgidywz60r">
                  Dentico Clinic · 360–364 City Road · London EC1V 2PY
                </span>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 mt-4" data-id="element-4603" data-mp="35huos4us4e17">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-4604" data-mp="35f8is9nje6l3">
                <Button size="sm" className="gap-2" data-id="element-4605" data-mp="3aecsr2iac8ch">
                  <Calendar className="w-4 h-4" data-id="element-4606" data-mp="3f6cosjv8ih3s" />
                  Book Online
                </Button>
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-id="element-4607" data-mp="3k4nvilq8gbhs">
                <Button variant="whatsapp" size="sm" className="gap-2" data-id="element-4608" data-mp="2mj0bl0ayrln5">
                  <MessageCircle className="w-4 h-4" data-id="element-4609" data-mp="2rhbmzfgwq47h" />
                  WhatsApp
                </Button>
              </a>
              <a href="tel:+447345197820" data-id="element-4610" data-mp="2wg4zp5oddr6l">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-4611" data-mp="2wf3ck2u2xe8i">
                  <Phone className="w-4 h-4" data-id="element-4612" data-mp="31gj0c2nn5yul" />
                  Request a Call
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}